/**
 * @file
 * Sticky top-bar bottom functionality.
 */
/* eslint-disable-next-line import/no-extraneous-dependencies */
import _ from "lodash";

(($, { behaviors }) => {
  /**
   * Un-sticks top-bar bottom from top of viewport.
   *
   * @param {jQuery} $topBarBottom
   *   A top-bar bottom DOM element.
   */
  function unStickHeaderBottomFromTop($topBarBottom) {
    $topBarBottom.removeClass("is-fixed");
  }

  /**
   * Sticks top-bar bottom to top of viewport.
   *
   * @param {jQuery} $topBarBottom
   *   A top-bar bottom DOM element.
   */
  function stickHeaderBottomToTop($topBarBottom) {
    $topBarBottom.addClass("is-fixed");
  }

  /**
   * Checks current scroll position.
   *
   * @param {jQuery} $topBarBottom
   *   A top-bar bottom DOM element.
   */
  function checkScrollPosition($topBarBottom) {
    const $document = $(document);
    const topBarBottomOffset = $topBarBottom.offset().top;
    $document.on(
      "scroll",
      _.throttle(() => {
        // Check if top-bar bottom is at top of viewport.
        if ($document.scrollTop() >= topBarBottomOffset) {
          stickHeaderBottomToTop($topBarBottom);
        } else {
          unStickHeaderBottomFromTop($topBarBottom);
        }
      }, 100)
    );
  }

  /**
   * Sticks or detaches the top-bar bottom from top of the viewport.
   *
   * @param {function} cb
   *   The callback that handles the response.
   * @param {number} debounceTime
   *   Duration after which the function is run.
   */
  function onWindowResizeAndLoad(cb, debounceTime = 250) {
    const $window = $(window);
    $window.on(
      "resize",
      _.debounce(() => {
        cb();
      }, debounceTime)
    );
    cb();
  }

  /**
   * Attaches behaviors for top-bar bottom to stick to top of viewport or not.
   *
   * @type {Drupal~behavior}
   *
   * @prop {Drupal~behaviorAttach} attach
   *  Attaches sticky top-bar bottom functionality.
   */
  behaviors.stickyTopBarBottom = {
    attach(context) {
      const $topBarBottom = $(".js-top-bar__bottom", context);
      const breakpointMedium = "(max-width: 1099px)";

      onWindowResizeAndLoad(() => {
        if (window.matchMedia(breakpointMedium).matches) {
          checkScrollPosition($topBarBottom);
        } else {
          unStickHeaderBottomFromTop($topBarBottom);
        }
      });
    },
  };
})(jQuery, Drupal);
